import { Icon } from "@mui/material";
import { Link } from "react-router-dom";

type Props = {
  to: string;
};

const Close = (props: Props) => {
  const { to } = props;
  return (
    <Link to={to}>
      <div
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          backgroundColor: "white",
          width: 20,
          height: 20,
          borderRadius: 100,
          padding: 10,
        }}
      >
        <Icon sx={{ fontSize: 20, color: "black" }}>close_rounded</Icon>
      </div>
    </Link>
  );
};

export default Close;
